import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'

import { redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/rates-and-packages/rateGroups/$rateGroupId/edit/'
)({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (auth.user?.role === Role['Front-Desk']) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },

  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
})
